/**
 * Created by Florin David on 28/09/2016.
 */
import Bluebird from 'bluebird'
import ReactDOM from 'react-dom/client'

import log from 'lib/log'

// import './style/index.global.scss'
// import './index.css' // Removed - Tailwind CSS removed from project

// import { addLocaleData } from 'react-intl'
// import ReactIntlLocaleDataRo from 'react-intl/locale-data/ro'

// import env from './config/env'
// import { installUpdate } from './scripts/offline-plugin'
import './scripts/error-handler'
// import './lib/store'

log.info('Starting app')

import ConnectedApp from './ConnectedApp'

// In order to make `.cancel` available on Bluebird Promises we need to change
// the configuration of the object
Bluebird.config({
  cancellation: true,
  warnings: false,
})

// install offline support for sites that are not local
// if (env.LOGGER_SITE && env.LOGGER_SITE.indexOf('local') === -1) {
//   installUpdate()
// }

/**
 * Render
 */
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<ConnectedApp />)
